import cn from 'classnames';
import type { FC } from 'react';
import { Controller, type Control } from 'react-hook-form';
import * as st from './styles.module.scss';

interface Props {
  control: Control<any>;
  name: string;
  label: string | undefined;
  disabled?: boolean;
  sufix?: string;
}

const CustomEditorInputControlled: FC<Props> = ({ control, label, name, disabled, sufix }) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    onChange: (...event: any[]) => void
  ) => {
    onChange(e.target.value);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => {
        return (
          <div className={cn(st.controller, !!error && st.error)}>
            <label
              className={cn(st.label, !!error && st.error, disabled && st.disabled)}
              htmlFor={name}
            >
              <p>{label}</p>
            </label>
            <div className={st.wrapper}>
              <input
                type="text"
                disabled={disabled}
                value={value ?? ''}
                onChange={(e) => handleChange(e, onChange)}
                onBlur={onBlur}
                className={cn(st.input, !!error && st.error)}
              />

              {sufix && <div className={cn(st.sufix, disabled && st.disabled)}>{sufix}</div>}
            </div>
          </div>
        );
      }}
    />
  );
};

export default CustomEditorInputControlled;
